export const DetailsClient = () => {
  return (
    <div>
      <h1 className="text-red-700">DETALHES DO CLIENTE</h1>
    </div>
  );
};
